import { createFileRoute, redirect } from '@tanstack/react-router';
import { TabbedPageLayout, type RoutedTab } from '@/components/tabbed-page-layout';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/web-browsing',
)({
  // The research agents' outbound web-search providers (Brave, Tavily) — the
  // `web_search` waterfall + per-provider credentials. Shares the enrichment
  // settings components, scoped to the `web_search` slot.
  component: () => (
    <TabbedPageLayout
      title="Web Browsing"
      description="Web-search providers for the research agents and the search waterfall."
      tabs={TABS}
    />
  ),
  beforeLoad: async ({ context }) => {
    if (context.platformRole !== 'admin') {
      throw redirect({ to: '/' });
    }
  },
});

const TABS: RoutedTab[] = [
  { to: '/super-admin/web-browsing/configuration', label: 'Configuration' },
  { to: '/super-admin/web-browsing/providers', label: 'Providers' },
];
